var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98615",
    "data-name": "Group 98615",
    transform: "translate(-33 -553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_907",
    "data-name": "Ellipse 907",
    transform: "translate(33 553)",
    fill: "#fff",
    stroke: "#e2e2f8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shopping-list",
    transform: "translate(-17.845 562.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98607",
    "data-name": "Group 98607",
    transform: "translate(67.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98606",
    "data-name": "Group 98606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215603",
    "data-name": "Path 215603",
    d: "M167.192,1.308h-1.42a1.962,1.962,0,0,0-3.7,0h-1.419a.654.654,0,0,0-.654.654V4.576a.654.654,0,0,0,.654.654h6.538a.654.654,0,0,0,.654-.654V1.961A.654.654,0,0,0,167.192,1.308Z",
    transform: "translate(-160)",
    fill: "#e2e2f8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98609",
    "data-name": "Group 98609",
    transform: "translate(64 2.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98608",
    "data-name": "Group 98608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215604",
    "data-name": "Path 215604",
    d: "M78.383,64H77.076v1.961a1.964,1.964,0,0,1-1.961,1.961H68.576a1.964,1.964,0,0,1-1.961-1.961V64H65.308A1.31,1.31,0,0,0,64,65.308V81a1.293,1.293,0,0,0,1.308,1.308H78.383A1.293,1.293,0,0,0,79.691,81V65.308A1.293,1.293,0,0,0,78.383,64ZM71.654,75.577l-2.615,2.615a.657.657,0,0,1-.926,0l-1.308-1.308a.654.654,0,0,1,.924-.924l.846.845,2.152-2.152a.654.654,0,0,1,.926.924Zm0-5.23-2.615,2.615a.657.657,0,0,1-.926,0l-1.308-1.308a.654.654,0,0,1,.924-.924l.846.845,2.152-2.152a.654.654,0,0,1,.926.924Zm4.767,6.729H73.807a.654.654,0,0,1,0-1.308h2.615a.654.654,0,0,1,0,1.308Zm0-5.23H73.807a.654.654,0,0,1,0-1.308h2.615a.654.654,0,0,1,0,1.308Z",
    transform: "translate(-64 -64)",
    fill: "#e2e2f8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus11);
export default __webpack_public_path__ + "static/media/status11.436b734a22c2d27d00f5bf8b32db9aa0.svg";
export { ForwardRef as ReactComponent };